import { getDataCollectionTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { icons } from '@/assets/icons'

export async function buildCompanyQuestionnaire(taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getDataCollectionTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching data collection task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Help us get your company setup',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/company-questionnaire/' + task.taskId, 
    createdDate: new Date(task.createdDate),
    icon: icons.form
  }
  
  return card 
}

